<template>
    <div>

        <div class="dashboard web" :style="'background-image:url('+require('@/assets/bodybg.jpg')+')'">
            <div class="basebox">
                
                <div class="imgbox">
                    <a href="http://js720.jsvisual.com:8780" target="window_view">
                        <img src="@/assets/1.png" alt="">
                    </a>
                    <a href="http://js720.jsvisual.com:8781" target="window_view">
                        <img src="@/assets/2.png" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="dashboard mobile" :style="'background-image:url('+require('@/assets/mobilebg.jpg')+')'">
            <a class="mobilebtnbox" href="http://js720.jsvisual.com:8780">
                <img class="mobilebtn" src="@/assets/1.png" alt="">
            </a>
            <a class="mobilebtnbox2" href="http://js720.jsvisual.com:8781">
                <img class="mobilebtn" src="@/assets/2.png" alt="">
            </a>
        </div>
    </div>
</template>
<script>
// import '@/config/flexible_css.js'
// import '@/config/flexible.js'
export default {
    name:'Dashboard',
    components:{
    },
    data:() => ({
       
    }),
    mounted(){
        
    },
    methods:{
        
    }
}
</script>
<style scoped lang="scss">
    $color:rgba(208,181,143,1);
    $bgcolor: rgba(213,180,138,1);
    $boxBgColor:#ae3d3d;
    .banner{
        width:100%;
        overflow:hidden;
        margin-bottom:10px;
        img{
        float:left;
        width:100%;
        }
    }
    .dashboard{
        background-color:rgba(233,233,233,1);
        // background-position: left top;
        // min-height: 1080px;
        // background-size: contain;
        background-repeat: no-repeat;
        position:fixed;
         top: 0;
         left: 0;
         width:100%;
         height:100%;
        //  min-width: 1000px;
         z-index:10;
         zoom: 1;
         background-size: cover;
         -webkit-background-size: cover;
         -o-background-size: cover;
         background-position: center;
          // background-repeat: no-repeat;
        // padding:13px 0 40px;
    }
    .webbtn{
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-left: -151px;
        margin-top: 125px;
        width: 302px;
        height: 82px;
        border-radius: 35px;
        background-clip: padding-box;
        z-index: 99;
        cursor: pointer;
        overflow: hidden;
        .webbtnpic{
            width: 100%;
            height: 100%;
        }
        .titlelight{
            width: 355px;
            position: absolute;
            left: 0;
            top: 10px;
            animation: weblight 3s infinite;
        }
    }
    
    .basebox{
        width: 1062px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom:38px;
        .imgbox{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-content: center;
            a{
                display: block;
                cursor: pointer;
                
            img{
               width: 100%;
               height: 100%;
            }
               &:hover{
                   img{
                    transform: scale(1.1);
                    transition: all 0.2s;
                   }
               }
            }
        }
    }

    /* 动画代码 */
    @keyframes weblight {
    from {left:-355px;}
    to {left:607px;}
    }
    @keyframes mobilebtn {
    from {left:-545px;}
    to {left:1012px;}
    }
    .mobile{
        display: none;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        .mobilebtnbox,.mobilebtnbox2{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom:15%;
            width: 457px;
            overflow: hidden;
            .mobilebtn{
                width: 100%;
            }
            .mobilelight{
                width: 545px;
                position: absolute;
                left:545px;
                top:0;
                animation: mobilebtn 3s infinite;
            }
        }
        .mobilebtnbox2{
            bottom:5%;
        }
    }
    @media screen and (max-width:1060px) {
      .mobile{
        display:block;
      }
      .web{
          display: none;
      }
  }
</style>